// codegen:start {preset: barrel, include: './lib/*.{ts,tsx}', exclude: './lib/*.{test,spec}.{ts,tsx}'}
export * from './lib/embed-shadow-dom';
export * from './lib/shadow-portal'; // codegen:end